export const frenchDate = (dateString) => {
    return dateString ? new Date(dateString).toLocaleDateString('fr-FR') : null
}

export const sqlDate = (dateString) => {
    return dateString ? dateString.slice(0, 10) : null
}
